
// Func = limiting Scope for this file

if (!Object.entries){
    Object.entries = function( obj ){
      var ownProps = Object.keys( obj ),
          i = ownProps.length,
          resArray = new Array(i); // preallocate the Array
      while (i--)
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
  
      return resArray;
      }
  }
  
  
  var lastScrollTop = 0;
  var page = 1, items_by_page = 6, config = null, pinsData=[],GOOGLE_MAPS_WRAPPER=null,MAP,HOTEL_PIN,GoogleMapsMarkers = [],$GoogleMaps = [];
  function resizeWindow(){};
  function scrollDown(){};

  let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

  if (isMobile) {

            // // Open active sub-nav on load
            $('#primary-nav ul.submenu li .active').closest('.inner').addClass('open')
            $('#primary-nav ul.submenu li .active').parents().parents('li').addClass('item-open');
            $('#primary-nav ul.submenu li .active').closest('.submenu').slideDown(300, function() {}).addClass('menu-open');


            //Toggle open/close on tap
            $('#primary-nav li a').off('click').on('click', function(event) {
                if ( $(this).parent().children(".submenu").length > 0 ) {

                    event.preventDefault();

                    if ($(this).next().hasClass('menu-open')) {
                        $(this).closest('.inner').removeClass('open');
                        $('#primary-nav ul li').removeClass('item-open');
                        $(this).parent().addClass('item-open');
                        $(this).next().slideUp(300, function(){
                            if($('#primary-nav ul li a').hasClass('active')){
                                $(".item-open").get(0).scrollIntoView(false);
                            } 
                        }).removeClass('menu-open');	                
                    } else {
                        $(this).closest('.inner').addClass('open');
                        $('#primary-nav ul li').removeClass('item-open');
                        $(this).parent().addClass('item-open');
                        $('.submenu.menu-open').slideUp(300).removeClass('menu-open'); 
                        $(this).next().addClass('menu-open').slideDown(300, function(){
                            if($('#primary-nav ul li a').hasClass('active')){
                                $(".item-open").get(0).scrollIntoView(false);
                            }
                        });
                    }
                }
            });

        }

  
  

  $('.grid-block__bottom-slider').each(function(){
    let self = $(this);
    if(self.children().length > 2){
        self.slick({
            slidesToShow: 3,
            accessibility:true,
            arrows:true, 
            dots:false, 
            infinite:true,
            responsive: [
                {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                },
                },
                {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    dots:true, 
                    arrows:false 

                }
                }
            
                
            ]

        });
    }

    // if (isMobile) {
	
    //     if(self.children().length > 1){
    //         self.slick({
    //             responsive: [
    //                  {
    //                 breakpoint: 600,
    //                 settings: {
    //                     slidesToShow: 1,
    //                     dots:true, 
    //                     arrows:false 
    
    //                 }
    //                 }
                
                    
    //             ]
    
    //         });
    //     }

    // }


   
    
});
  
  
  (function(){

      $(document).ready(function () {
          $('.go-top').click(function(){
              $('html,body').animate({
                  scrollTop: 0
              },2000);
          })
  
          $('.slider__content').on('init', function(event, slick){
            const next_title = $('.slick-current').next().find('h3').text();
            $('.slider__next').html(next_title);
            const prev_title = $('.slick-current').prev().find('h3').text();
            $('.slider__prev').html(prev_title);
          });
  
          $('.slider__content').on('afterChange', function(event, slick, currentSlide, nextSlide){
            const next_title = $('.slick-current').next().find('h3').text();
            $('.slider__next').html(next_title);
            const prev_title = $('.slick-current').prev().find('h3').text();
            $('.slider__prev').html(prev_title);
          });

    
          $('.slider__content_img').slick({
          accessibility: false,
          centerMode : true, 
          variableWidth: true, 
          arrows: false,
          asNavFor: '.slider__content',
          responsive: [
                  {
                    breakpoint: 600,
                    settings: {
                        dots:false,
                        arrows: false,
                        slidesToShow: 1,
                        centerMode : false,
                        adaptiveHeight: true,
                        variableWidth: false
                    }
                  }
                ]
          });
          $('.slider__content').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            asNavFor: '.slider__content_img',
            responsive: [
                    {
                      breakpoint: 600,
                      settings: {
                          dots:true,
                          arrows: false,
                          slidesToShow: 1,
                          centerMode : false,
                          adaptiveHeight: true,
                          variableWidth: false
                      }
                    }
                  ]
            });
  
  
          $('.slider__content-gallery').on('init', function(event, slick){
            const next_title = $('.slick-current').next().find('h3').text();
            $('.slider__next').html(next_title);
            const prev_title = $('.slick-current').prev().find('h3').text();
            $('.slider__prev').html(prev_title);
          });
  
          $('.slider__content-gallery').on('afterChange', function(event, slick, currentSlide, nextSlide){
            const next_title = $('.slick-current').next().find('h3').text();
            $('.slider__next').html(next_title);
            const prev_title = $('.slick-current').prev().find('h3').text();
            $('.slider__prev').html(prev_title);
          });
         


          $('.slider__content-gallery').slick({
            accessibility: false,
            centerMode : true, 
            prevArrow: $('.prev-arrow'),
            nextArrow: $('.next-arrow'),  
            variableWidth: true, 
            responsive: [
                    {
                      breakpoint: 600,
                      settings: {
                          dots:false,
                          arrows: true,
                          slidesToShow: 1,
                          centerMode : false,
                          adaptiveHeight: false,
                          variableWidth: false
                      }
                    }
                  ]
            });
  
            
         
  
          //Call function with browser is resized.
          $(window).resize(function (event) {
              resizeWindow();
          });
          resizeWindow();


         

        $('.close-menu').click(function(event) {
            event.preventDefault();
            $('html').removeClass('hide-overflow');
            $('.nav-desktop').removeClass('open');
            $('.nav-desktop').stop().animate({left:'100%'},{queue:false,duration:300});
        });
    
          //Acts when scroll down page.
          $(window).scroll(function (event) {
              scrollDown();
          });

          if (!isMobile) {
  
          // Main Nav Dropdown
          $("#primary-nav li").hover(function(){
              $(this).addClass("hover");
              $('ul.submenu',this).fadeIn(200);
          }, function(){
              $(this).removeClass("hover");
              $('ul.submenu',this).fadeOut(200);
          });
        }
          

        if (isMobile) {
  
            // Main Nav Dropdown
            $("#primary-nav li").click(function(){
                $(this).addClass("item-open");
                $('ul.submenu',this).fadeIn(200);
            });
          }
            
        if (!isMobile && document.querySelector(`header.home-position`)) {

            let header = document.querySelector(`header.home-position`);
            window.addEventListener( 'scroll', () => {
                if( window.scrollY > (window.innerHeight - 100) ){
                    if( !header.classList.contains('header-fixed-top') ){
                        header.classList.add('blinking');
                        setTimeout(() => {
                            header.classList.remove('blinking');
                        }, 500);
                    }
                    header.classList.add('header-fixed-top');
                }else{
                    if( header.classList.contains('header-fixed-top') ){
                        header.classList.add('blinking');
                        setTimeout(() => {
                            header.classList.remove('blinking');
                        }, 500);
                    }
                    header.classList.remove('header-fixed-top');
                }
            } );
             
        }


           //Open Navigation
        $('#menu-btn').click(function(event) {
            $('html').addClass('hide-overflow');
            $('.nav-desktop').addClass('open');
            $('.nav-desktop').stop().animate({left:'0px'},{duration:300});
            if($('.nav-desktop ul li a').hasClass('.item-open')){
                $(".item-open").get(0).scrollIntoView(false);
            }
        });

     
          if ($("body").hasClass("en")) {

            $('.book-now-button').click(function(){
                $('body').find('.booking-container').toggleClass('open');
                if ($('body').find('.booking-container').hasClass('open')) {
                    $('.book-now-button').text("close");
                    $('.book-now-button').addClass("btn-open");                        
                  } else {
                    $('.book-now-button').text("book now");  
                    $('.book-now-button').removeClass("btn-open");
                  }
            });
    
		}


		

          
        
        
  
          $('.header__lang-active').click(function(){
              $(this).next('.header__lang-select').toggleClass('open');
          });
  
          
  
          // Map: Return to previous page button. Change body id to match map template's name.
          //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
  
      
  
          $('.top-content__arrow a').click(function(event){
              event.preventDefault();
              let thishref = $(this).attr('href');
              var hashTop = $(thishref).offset().top;
              $('html,body').animate({scrollTop:hashTop-70},1500);
          });
  
        
      });
  
      /**************************************************************************************************************************************************************
       * Function open reserve
       ****************************************************************************************************************************************************************/
     
  
      $('.footer__nav a').click(function(event){
          event.preventDefault();
          const this_href = $(this).attr('href');
          $('.portfolio-cat').hide();
          $(this_href).fadeIn();
          $('.footer__nav a').removeClass('active');
          $(this).addClass('active');
      });
  
      window.onload = function() {
          /*this function add a class to header when scroll down the page
          /* and change the logo by a new file if needed depending of mockup
          */
  
          scrollDownAction(20, 'scroll');
  
          scrollW();
          window.addEventListener('scroll', function(){
              scrollW();
          })
      };
  
      /**************************************************************************************************************************************************************
       * LIGHTBOX
       ****************************************************************************************************************************************************************/
    //   const LIGHTBOX_OPENED__CLASS = "opened-lightbox";
    //   function OpenLightbox(element) {
    //       //Get Pin ID and then info
    //       const PinInfo = pinsData[element];
    //       //Get Pin Info
    //       let markup = getPinMarkLighbox(PinInfo);
    //       LIGHTBOX_WRAPPER.innerHTML = markup;
    //       //document.querySelector("body").style.overflowY = 'hidden';
    //       LIGHTBOX__FULL_WRAPPER.classList.add(LIGHTBOX_OPENED__CLASS);
    //   }
  
    //   function CloseLigthbox(event) {
    //       if (event.keyCode === undefined && !event.target.classList.contains(LIGHTBOX_OPENED__CLASS) && event.target.id !== LIGHTBOX__CLOSE_BUTTON) return false;
    //       LIGHTBOX_WRAPPER.innerHTML = "";
    //       LIGHTBOX__FULL_WRAPPER.classList.remove(LIGHTBOX_OPENED__CLASS);
    //       document.querySelector("body").style.overflowY = 'visible';
    //   }
  
    //   LIGHTBOX__FULL_WRAPPER.addEventListener('click', (event) => CloseLigthbox(event));
    //   $LIGHTBOX__CLOSE_BUTTON.addEventListener('click', (event) => CloseLigthbox(event));
  
  }());
  
  function scrollW(){
      //check scroll down or up for header styles
      let st = window.pageYOffset || document.documentElement.scrollTop;
      if(st > 80){
          if (st > lastScrollTop){
              // downscroll code
              if(!document.getElementById('header').classList.contains('down')){
                  document.getElementById('header').classList.add('down');
                  document.getElementById('header').classList.remove('up');
              }
          } else {
              // upscroll code
              if(!document.getElementById('header').classList.contains('up')){
                  document.getElementById('header').classList.add('up');
                  document.getElementById('header').classList.remove('down');
              }
          }
      } else {
          if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
              document.getElementById('header').classList.remove('up');
              document.getElementById('header').classList.remove('down');
          }
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  
      const window_height = window.innerHeight;
      let animatedEl = document.getElementsByClassName('animate-fade-2');
      for (let i = 0; i < animatedEl.length; i++) {
          var viewportOffset = animatedEl[i].getBoundingClientRect();
          let topPos = viewportOffset.top;
          if(topPos <= window_height*0.8){
              animatedEl[i].classList.add('fade-in');
          }
      }
  }
  
  function goPage( num, object ){
      
      if(object != undefined){
          $( ".paginator a" ).removeClass( "active" );
          $( object ).addClass( "active" );
      }
      
      var first_item = items_by_page * num;
      var last_item = first_item + items_by_page;
      $.each( $( ".offers-search__col.div" ), function( index, value ){
  
          if( index < first_item )
              $( value ).css( "display", "none" );
          else if( index >= first_item && index < last_item )
              $( value ).css( "display", "flex" );
          else
              $( value ).css( "display", "none" );
  
      } )
      const first = (num+1);
      let  lostNum = 1;
      if(first>1)
          lostNum = (num*items_by_page)+1;
      const total = $( ".offers-search__col.div" ).length;
      const length= first*items_by_page;
      
  
      return false;
  }
   
  function generatePaginator(){
  
      $( ".paginator" ).remove();
  
      var count = $('.offers-search__col.div').length;
      var html = "<div class='paginator'>";
      var floor = count/items_by_page;
      if(count>items_by_page){
          for( var i = 0 ; i <  floor ; i++ ){
              html += "<a href='#result-list' ";
              if(i == 0) { html += 'class="active"';}
              html += " onclick='goPage("+i+", this)'>" + (i+1) + "</a> ";
          }
      }
      html += "<div>";
  
      $( "#result-list" ).append( html ); 
  }
  
  function removeDuplicateHtml(names,type){
      let uniqueNames = [];
      let html 		= '';
      //Remove Duplicates.
      $.each(names, function(i, el){
          if($.inArray(el, uniqueNames) === -1) uniqueNames.push(el);
      });
      //Sort alphabetically.
      uniqueNames.sort(function(a, b){
          if(a < b) { return -1; }
          if(a > b) { return 1; }
          return 0;
      })
      //write result by type of field.
      switch (type) {
          case 'li':
              uniqueNames.forEach(element => {
                  let this_class =  element.replace(/ /g, '_');
                  this_class = this_class.replace('.', '-');
                  html += '<li data-filter="'+this_class+'">'+element+'</li>';
              });
              break;
      
          default:
              uniqueNames.forEach(element => {
                  let this_class =  element.replace(/ /g, '_');
                  this_class = this_class.replace('.', '-');
                  html += '<option data-filter="'+this_class+'" value="'+element+'">'+element+'</option>';
              });
              break;
      }
  
      return html;
  }
  